import React, { useEffect, useState } from "react";
import "./SalesDetails.scss";
import { useLocation, useNavigate } from "react-router-dom";

import { FaUser } from "react-icons/fa";
import { CiCalendar } from "react-icons/ci";
import { HiCube } from "react-icons/hi2";
import { FaRegStickyNote } from "react-icons/fa";
import { IoReceiptOutline } from "react-icons/io5";
import { FaPlus, FaMinus } from "react-icons/fa6";
import { IoCheckmarkSharp } from "react-icons/io5";

import { format } from "date-fns";

import ROUTES from "../../../constants/routes";
import { useDispatch, useSelector } from "react-redux";
import { PaymentMethods } from "../../../constants/paymentMethods";
import CustomButton from "../../../components/CustomButton/CustomButton";
import { deleteSale, returnSaleItems } from "../../../api/sales";
import { toast } from "react-toastify";
import { IoIosArrowBack } from "react-icons/io";
import useOrganizationIsAllowed from "../../../helpers/organizationPrevillages";
import { updateOpenSubscriptionAd } from "../../../redux/features/subscription-slice";
import { loadAnalytics } from "../../../redux/features/analytics-slice";
import useUserIsAllowed from "../../../helpers/userAuthorized";
import { fetchSalesData } from "../../../redux/features/home-slice";
import { updateExistingProduct } from "../../../redux/features/products-slice";
import { useViewPortDetector } from "../../../helpers/viewPortDetector";
import { updateExistingOrder } from "../../../redux/features/orders-slice";
import { updateExistingSale } from "../../../redux/features/sales-slice";

const SalesDetails = ({
  desktopView,
  sale,
  setSelectedDesktopTag,
  order,
  setSelectedSale,
}) => {
  const location = useLocation();
  const navigate = useNavigate();

  const itemDetails = desktopView ? sale : location.state?.item;
  const userData = location.state?.userData || {};
  const isOrder = location.state?.isOrder || order || false;
  const customerData = location.state?.customerData || null;

  const dispatch = useDispatch();

  const { currency, id: organization_id } = useSelector(
    (state) => state.organizationReducer.value
  );
  const { id: branch_id } = useSelector((state) => state.branchReducer.value);
  const { run } = useSelector((state) => state.tourReducer.value);
  const { tour_sales } = useSelector((state) => state.userReducer.value);

  const isAllowedToReturnSales = useUserIsAllowed("sales_returns");

  const orgIsAllowedForReturnProduct = useOrganizationIsAllowed(
    "return_or_store_credit"
  );

  const [transactionDetails, setTransactionDetails] = useState(null);

  const [openConfirmModel, setOpenConfirmModel] = useState(false);
  const [openReturnModel, setOpenReturnModel] = useState(false);

  const [selectedItems, setSelectedItems] = useState([]);

  const [customerId, setCustomerId] = useState(null);

  const [returnedItems, setReturnedItems] = useState([]);

  const { currentViewPort, isReady } = useViewPortDetector();

  const userIsAdministrator = useUserIsAllowed("administrator");
  const userIsAllowedToManageInventory = useUserIsAllowed("manage_inventory");

  const userIsAllowedToCancelSale =
    userIsAdministrator || userIsAllowedToManageInventory;

  useEffect(() => {
    if (!desktopView && currentViewPort === "desktop" && isReady) {
      navigate(ROUTES.sales.path);
    }
  }, [currentViewPort, isReady]);

  useEffect(() => {
    if (!desktopView && currentViewPort === "desktop") {
      navigate(ROUTES.sales.path);
    } else {
      if (!(itemDetails && itemDetails?.id) && !(run && tour_sales)) {
        if (location.pathname === ROUTES.salesDetails.path) {
          navigate(ROUTES.sales.path);
        } else {
          navigate(ROUTES.orders.path);
        }
      } else {
        if (itemDetails?.customer?.id) {
          setCustomerId(itemDetails?.customer?.id);
        } else {
          setCustomerId(null);
        }
        setTransactionDetails(itemDetails);
      }
    }
  }, [itemDetails, run, tour_sales, currentViewPort]);

  useEffect(() => {
    const returned_items = transactionDetails?.products?.filter(
      (el) => el?.return
    );
    setReturnedItems(returned_items || []);
  }, [transactionDetails]);

  return (
    <div className="sales-details" id="tour-sales-details">
      <div className="container-wrapper detailed-container">
        <div className="cash-details">
          <p
            className={`item-id ${
              transactionDetails?.deleted_at ? "deleted" : ""
            }`}
          >
            # {transactionDetails?.sale_id}
          </p>
          <div className="upper">
            <p className="price">
              {currency}{transactionDetails?.total_amount}
            </p>
            <div className="discount-delivery">
              <p className="danger">
                Discount {`(${transactionDetails?.percent_discount}%):`}{" "}
                {currency}{transactionDetails?.cash_discount}
              </p>
              <p>
                Delivery: {currency}{transactionDetails?.delivery_charge}
              </p>
              <p>
                Tax: {currency}{transactionDetails?.tax}
              </p>
              {transactionDetails?.user?.id && (
                <p className="sold-by">
                  <span>Sold By:</span>
                  {transactionDetails?.user?.name}
                </p>
              )}
              {transactionDetails?.deleted_at && (
                <p className="danger">
                  Canceled At:{" "}
                  {format(transactionDetails?.deleted_at, "dd/MM/yyyy")}
                </p>
              )}
              {transactionDetails?.deleted_by?.name && (
                <p className="danger">
                  Canceled By: {transactionDetails?.deleted_by?.name}
                </p>
              )}
            </div>
          </div>
          <div className="lower">
            <div className="payment-methods">
              {transactionDetails?.sale_payment_methods?.map((el, i) => {
                let item = PaymentMethods.find(
                  (item) => item.value === el?.payment_method
                );
                if (item) {
                  return (
                    <div key={i} className="item">
                      {item.icon} {item.name}{" "}
                      <span>{`(${currency}${el?.amount})`}</span>
                    </div>
                  );
                } else {
                  return null;
                }
              })}
            </div>
            <div className="customer-details">
              <p
                className="cust"
                onClick={() => {
                  if (transactionDetails?.customer?.id) {
                    navigate(ROUTES.customers.path, {
                      state: {
                        searchKeyword: `${
                          transactionDetails?.customer?.phone_number ||
                          transactionDetails?.customer?.name ||
                          ""
                        }`,
                      },
                    });
                  }
                }}
              >
                {transactionDetails?.customer?.name ? <FaUser /> : ""}
                {transactionDetails?.customer?.name || ""}
              </p>

              <p>
                <CiCalendar />
                {transactionDetails?.created_at
                  ? format(transactionDetails?.created_at, "dd/MM/yyyy")
                  : "dd/MM/yyyy"}
              </p>
            </div>
          </div>
        </div>

        <div className="item-details">
          <div className="heading">
            <HiCube />
            <p>Items</p>
          </div>

          <div className="items">
            {transactionDetails?.products?.map((el, i) => {
              let quantity = el?.nonInventory
                ? Number(el?.quantity) || 0
                : Number(el?.pivot?.quantity) || 0;
              let per_price = el?.nonInventory
                ? Number(el?.price) || 0
                : Number(el?.pivot?.price) || 0;
              let discount = el?.nonInventory
                ? Number(el?.discount) || 0
                : Number(el?.pivot?.discount || 0);
              let totalPrice = Number(quantity * per_price - discount).toFixed(
                2
              );
              return (
                <div className="item" key={i}>
                  <p>{`${quantity} x ${el?.name}`}</p>
                  <p className="price">
                    {currency}{totalPrice}
                  </p>
                </div>
              );
            })}
          </div>

          {!transactionDetails?.deleted_at &&
            transactionDetails?.id !== "offline" && (
              <div
                className="rounded-danger-btn"
                id="tour-return-button"
                onClick={() => {
                  if (orgIsAllowedForReturnProduct.exists) {
                    if (isAllowedToReturnSales) {
                      if (customerId) {
                        setOpenReturnModel(true);
                      } else {
                        toast.dismiss(); toast.info(
                          "Customer required for this sale for refunding/returning!"
                        );
                        if (desktopView) {
                          setSelectedDesktopTag("Select Customer For Sale");
                        } else {
                          navigate(ROUTES.saleCustomer.path, {
                            state: {
                              salesDetails: transactionDetails,
                              userData,
                              customerData,
                            },
                          });
                        }
                      }
                    } else {
                      toast.dismiss(); toast.info(
                        "You do not have sufficient permissions to perform this action. Please contact your administrator."
                      );
                    }
                  } else {
                    dispatch(updateOpenSubscriptionAd({ openAd: true }));
                  }
                }}
              >
                <p>Return/Refund</p>
              </div>
            )}
        </div>

        {returnedItems?.length > 0 && (
          <div className="item-details">
            <div className="heading">
              <HiCube />
              <p>Returned Items</p>
            </div>

            <div className="items">
              {returnedItems?.map((el, i) => {
                let quantity = Number(el?.return?.quantity) || 0;
                let per_price = Number(el?.pivot?.price) || 0;
                let totalPrice = Number(quantity * per_price).toFixed(2);
                return (
                  <div className="item" key={i}>
                    <p>{`${quantity} x ${el?.name}`}</p>
                    <p className="price">
                      {currency}{totalPrice}
                    </p>
                  </div>
                );
              })}
            </div>

            <div className="returned-by">
              <p>
                Returned By:{" "}
                {returnedItems?.map((el, i) => {
                  return (
                    <span>
                      {i === returnedItems?.length - 1
                        ? el?.return?.returned_by?.name
                        : ""}
                    </span>
                  );
                })}
              </p>
            </div>
          </div>
        )}

        <div className="note">
          <div className="heading">
            <FaRegStickyNote />
            <p>Note</p>
          </div>

          <p className="content">
            {transactionDetails?.note && transactionDetails?.note !== "null"
              ? transactionDetails?.note
              : "No Note Added."}
          </p>
        </div>
        {!transactionDetails?.deleted_at &&
          transactionDetails?.id !== "offline" && (
            <div className="floating-buttons">
              {!isOrder && (
                <div
                  className="print"
                  onClick={() => {
                    if (desktopView && setSelectedDesktopTag) {
                      setSelectedDesktopTag("PDF");
                    } else {
                      navigate(ROUTES.salesPdf.path, {
                        state: {
                          saleId: transactionDetails?.id,
                          userData,
                          salesDetails: transactionDetails,
                          customerData: customerData,
                        },
                      });
                    }
                  }}
                >
                  <IoReceiptOutline />
                </div>
              )}

              <CustomButton
                name={"Cancel Transaction"}
                id={"tour-cancel-button"}
                type={"button"}
                color={"danger"}
                bigButton={true}
                handleSubmit={() => {
                  if (userIsAllowedToCancelSale) {
                    setOpenConfirmModel(true);
                  } else {
                    toast.dismiss(); toast.info(
                      "You do not have sufficient permissions to perform this action. Please contact your administrator."
                    );
                  }
                }}
              />
            </div>
          )}
      </div>

      <ConfirmModel
        openConfirmModel={openConfirmModel}
        setOpenConfirmModel={setOpenConfirmModel}
        openReturnModel={openReturnModel}
        transactionId={transactionDetails?.id}
        selectedItems={selectedItems}
        organizationId={organization_id}
        branchId={branch_id}
        userData={userData}
        customerData={customerData}
        selectedSale={sale}
        setSelectedSale={setSelectedSale}
        setOpenReturnModel={setOpenReturnModel}
      />

      <ReturnModel
        openReturnModel={openReturnModel}
        setOpenReturnModel={setOpenReturnModel}
        setOpenConfirmModel={setOpenConfirmModel}
        products={
          transactionDetails?.products ? [...transactionDetails?.products] : []
        }
        selectedItems={selectedItems}
        setSelectedItems={setSelectedItems}
      />

      {(openConfirmModel || openReturnModel) && (
        <div
          style={openConfirmModel ? { zIndex: 420 } : {}}
          className={`blur-back ${
            openConfirmModel && desktopView ? "desktop" : ""
          }`}
          onClick={() => {
            if (openConfirmModel && openReturnModel) {
              setOpenConfirmModel(false);
            } else {
              setOpenReturnModel(false);
              setOpenConfirmModel(false);
            }
          }}
        ></div>
      )}
      {(userData?.id || customerData?.id) && (
        <div
          className="navigation-back-button"
          onClick={() => {
            if (customerData) {
              navigate(ROUTES.customerDetails.path, {
                state: {
                  customerData: customerData,
                },
              });
            } else {
              navigate(ROUTES.manageUserBranches.path, {
                state: {
                  userData: userData,
                  selectedTab: isOrder ? "orders" : "sales",
                },
              });
            }
          }}
        >
          <IoIosArrowBack />
        </div>
      )}
      {!userData?.id && isOrder && (
        <div
          className="navigation-back-button"
          onClick={() => {
            navigate(ROUTES.orders.path);
          }}
        >
          <IoIosArrowBack />
        </div>
      )}
    </div>
  );
};

export default SalesDetails;

const ReturnModel = ({
  openReturnModel,
  setOpenReturnModel,
  setOpenConfirmModel,
  products,
  selectedItems,
  setSelectedItems,
}) => {
  useEffect(() => {
    if (!openReturnModel) {
      setSelectedItems([]);
    }
  }, [openReturnModel]);
  const { currency } = useSelector((state) => state.organizationReducer.value);
  const addReturnItem = (item, isSelected) => {
    if (isSelected) {
      let tempArray = [...selectedItems];
      let itemIndex = tempArray.findIndex((el) => el?.id === item?.id);
      if (itemIndex !== -1) {
        tempArray.splice(itemIndex, 1);
        setSelectedItems(tempArray);
      }
    } else {
      let tempArray = [...selectedItems];
      let tempItem = {
        ...item,
        pivot: {
          ...item?.pivot,
          quantity: 1,
        },
      };
      tempArray.push(tempItem);
      setSelectedItems(tempArray);
    }
  };

  const handleRemoveQuantity = (item, allow, isSelected) => {
    if (allow) {
      if (isSelected) {
        let tempArray = [...selectedItems];
        let itemIndex = tempArray.findIndex((el) => el?.id === item?.id);
        if (itemIndex !== -1) {
          tempArray[itemIndex].pivot.quantity =
            Number(tempArray[itemIndex].pivot.quantity) - 1;
          setSelectedItems(tempArray);
        }
      } else {
        let tempArray = [...selectedItems];
        let tempItem = {
          ...item,
          pivot: {
            ...item?.pivot,
            quantity: 1,
          },
        };
        tempArray.push(tempItem);
        setSelectedItems(tempArray);
      }
    }
  };

  const handleAddQuantity = (item, allow, isSelected) => {
    if (allow) {
      if (isSelected) {
        let tempArray = [...selectedItems];
        let itemIndex = tempArray.findIndex((el) => el?.id === item?.id);
        if (itemIndex !== -1) {
          tempArray[itemIndex].pivot.quantity =
            Number(tempArray[itemIndex].pivot.quantity) + 1;
          setSelectedItems(tempArray);
        }
      } else {
        let tempArray = [...selectedItems];
        let tempItem = {
          ...item,
          pivot: {
            ...item?.pivot,
            quantity: 2,
          },
        };
        tempArray.push(tempItem);
        setSelectedItems(tempArray);
      }
    }
  };

  const [shouldRender, setShouldRender] = useState(false);

  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    if (openReturnModel) {
      setShouldRender(true);
      setTimeout(() => {
        setIsVisible(true);
      }, 10);
    } else if (isVisible) {
      setIsVisible(false);
      setTimeout(() => {
        setShouldRender(false);
      }, 300);
    }
  }, [openReturnModel, isVisible]);

  if (!shouldRender) return null;
  return (
    <div className={`return-model ${isVisible ? "active" : ""}`}>
      <p className="heading">Select the product you want to Return/Refund</p>

      {/* <p className="no-items">No items left to return.</p> */}

      <div className="product-items">
        {products?.map((el, i) => {
          let selectedItem = selectedItems.find((item) => item?.id === el?.id);
          let isSelected = selectedItem ? true : false;
          let productImg = "/images/noImage.svg";
          let remainingQuantity =
            Number(el?.pivot?.quantity || 0) -
            Number(el?.return?.quantity || 0);
          let itemQuantity = selectedItem
            ? Number(selectedItem?.pivot?.quantity)
            : 1;
          let allowMinus = itemQuantity > 1;
          let allowplus = itemQuantity < remainingQuantity;
          if (el?.nonInventory || remainingQuantity <= 0) {
            return null;
          } else {
            return (
              <div className="item" key={i}>
                <div
                  className="left"
                  onClick={() => {
                    addReturnItem(el, isSelected);
                  }}
                >
                  <div className={`checkbox ${isSelected ? "active" : ""}`}>
                    {isSelected && <IoCheckmarkSharp />}
                  </div>
                  <img
                    src={productImg}
                    alt="" aria-label={`${el?.name || "Product"}'s Image`}
                  />
                  <p>{el?.name}</p>
                  <p className="price">
                    {currency}{el?.pivot?.price}
                  </p>
                </div>

                <div className="right">
                  <p
                    className={`minus ${allowMinus ? "active" : ""}`}
                    onClick={() => {
                      handleRemoveQuantity(el, allowMinus, isSelected);
                    }}
                  >
                    <FaMinus />
                  </p>
                  <p>{itemQuantity}</p>
                  <p
                    className={`plus ${allowplus ? "active" : ""}`}
                    onClick={() => {
                      handleAddQuantity(el, allowplus, isSelected);
                    }}
                  >
                    <FaPlus />
                  </p>
                </div>
              </div>
            );
          }
        })}
      </div>
      <div className="buttons">
        <CustomButton
          name={"Cancel"}
          color={"danger"}
          type={"button"}
          handleSubmit={() => {
            setOpenReturnModel(false);
          }}
          disabled={false}
        />
        <CustomButton
          name={"Return/Refund"}
          color={"primary"}
          type={"button"}
          handleSubmit={() => {
            if (selectedItems && selectedItems?.length > 0) {
              setOpenConfirmModel(true);
            } else {
              toast.dismiss(); toast.info("No return items selected!");
            }
          }}
          disabled={false}
        />
      </div>
    </div>
  );
};

const ConfirmModel = ({
  openConfirmModel,
  setOpenConfirmModel,
  openReturnModel,
  transactionId,
  selectedItems,
  organizationId,
  branchId,
  userData,
  customerData,
  selectedSale,
  setSelectedSale,
  setOpenReturnModel,
}) => {
  const navigate = useNavigate();
  const [deleting, setDeleting] = useState(false);

  const dispatch = useDispatch();
  const { loaded: analyticsLoaded } = useSelector(
    (state) => state.analyticsReducer
  );

  const reloadAnalytics = () => {
    if (analyticsLoaded) {
      dispatch(
        loadAnalytics({
          organization_id: organizationId,
          branch_id: null,
          filter_type: null,
        })
      );
    }
  };

  const handleConfirm = () => {
    if (transactionId) {
      setDeleting(true);
      if (openReturnModel) {
        const filteredData = selectedItems?.map((el) => {
          return {
            sale_id: el?.pivot?.sale_id,
            product_sale_id: el?.pivot?.id,
            product_id: el?.pivot?.product_id,
            quantity: el?.pivot?.quantity,
          };
        });

        returnSaleItems(transactionId, { return_array: filteredData })
          .then((res) => {
            reloadAnalytics();
            dispatch(
              fetchSalesData({
                organization_id: organizationId,
                branch_id: branchId,
              })
            );
            if (res.data?.updated_products?.length > 0) {
              dispatch(
                updateExistingProduct({ products: res.data?.updated_products })
              );
            }
            toast.dismiss(); toast.success("Items return successfully.");
            if (customerData || userData?.id) {
              if (customerData) {
                navigate(ROUTES.customerDetails.path, {
                  state: { customerData: customerData },
                });
              } else {
                navigate(ROUTES.manageUserBranches.path, {
                  state: {
                    userData: userData,
                    selectedTab: "sales",
                  },
                });
              }
            } else {
              navigate(ROUTES.sales.path);
            }
            setSelectedSale && setSelectedSale(res.data?.sale);
            dispatch(updateExistingSale({ sale: res.data?.sale }));
            setOpenReturnModel(false);
            setOpenConfirmModel(false);
          })
          .catch((err) => {
            if (err?.response?.data?.message) {
              if (err?.response?.data?.message === "User not authorized!") {
                toast.dismiss(); toast.error(
                  "You do not have sufficient permissions to perform this action. Please contact your administrator."
                );
              } else {
                toast.dismiss(); toast.error(`${err?.response?.data?.message}`);
              }
            } else {
              toast.dismiss(); toast.error("Error while returning products!");
            }
          })
          .finally(() => {
            setDeleting(false);
          });
      } else {
        deleteSale(transactionId)
          .then((res) => {
            reloadAnalytics();
            dispatch(
              fetchSalesData({
                organization_id: organizationId,
                branch_id: branchId,
              })
            );
            if (res.data?.updated_products?.length > 0) {
              dispatch(
                updateExistingProduct({ products: res.data?.updated_products })
              );
            }
            toast.dismiss(); toast.success(`Sale transaction is cancelled successfully.`);
            if (customerData || userData?.id) {
              if (customerData) {
                navigate(ROUTES.customerDetails.path, {
                  state: { customerData: customerData },
                });
              } else {
                navigate(ROUTES.manageUserBranches.path, {
                  state: {
                    userData: userData,
                    selectedTab: "sales",
                  },
                });
              }
            } else {
              navigate(ROUTES.sales.path);
            }
            dispatch(
              updateExistingSale({
                sale: res.data?.sale,
              })
            );
            setSelectedSale && setSelectedSale(res.data?.sale);
            setOpenReturnModel(false);
            setOpenConfirmModel(false);
          })
          .catch((err) => {
            if (err?.response?.data?.message) {
              if (err?.response?.data?.message === "User not authorized!") {
                toast.dismiss(); toast.error(
                  "You do not have sufficient permissions to perform this action. Please contact your administrator."
                );
              } else {
                toast.dismiss(); toast.error(`${err?.response?.data?.message}`);
              }
            } else {
              toast.dismiss(); toast.error(`Error while canceling sale transaction.`);
            }
          })
          .finally(() => {
            setDeleting(false);
          });
      }
    }
  };

  const [shouldRender, setShouldRender] = useState(false);

  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    if (openConfirmModel) {
      setShouldRender(true);
      setTimeout(() => {
        setIsVisible(true);
      }, 10);
    } else if (isVisible) {
      setIsVisible(false);
      setTimeout(() => {
        setShouldRender(false);
      }, 300);
    }
  }, [openConfirmModel, isVisible]);

  if (!shouldRender) return null;
  return (
    <div className={`confirm-model ${isVisible ? "active" : ""}`}>
      <h1>{!openReturnModel ? "Cancel Transaction" : "Return/Refund"}</h1>

      <p>
        Are you sure you want to{" "}
        <span>{!openReturnModel ? "Cancel Transaction" : "Return/Refund"}</span>{" "}
        this {!openReturnModel ? "sale" : "product"}?
      </p>

      <div className="buttons">
        <CustomButton
          name={"Cancel"}
          color={"danger"}
          type={"button"}
          handleSubmit={() => {
            setOpenConfirmModel(false);
          }}
          disabled={deleting}
        />
        <CustomButton
          name={"Yes"}
          color={"primary"}
          type={"button"}
          handleSubmit={handleConfirm}
          disabled={deleting}
          loader={deleting}
        />
      </div>
    </div>
  );
};
